import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, serviceHead } from "@/components/site/ServicePage";

const SLUG = "baeredygtighed";
const TITLE = "Bæredygtighed | Elektriker-Elektriker København";
const DESC =
  "Sådan arbejder vi grønt: elbil-flåde, optimerede ruter, genbrug og fokus på løsninger der sænker kundernes CO2-aftryk. Læs om vores bæredygtige drift og rådgivning.";

export const Route = createFileRoute("/baeredygtighed")({
  head: () => serviceHead(SLUG, TITLE, DESC),
  component: () => (
    <ServicePage
      slug={SLUG}
      heroVariant="centered"
      accentColor="oklch(0.7 0.14 145)"
      eyebrow="Bæredygtighed"
      title="Vi tager det grønne ansvar alvorligt"
      intro="Som elektrikervirksomhed har vi en særlig position til at skubbe på den grønne omstilling, både i vores egen drift og gennem de løsninger vi anbefaler vores kunder. Det er hverken greenwashing eller marketingsnak; det er hvordan vi driver virksomheden."
      longIntro={
        <>
          <h2>Vores eget aftryk</h2>
          <p>
            Vi kører elbiler på vores servicebiler, opladet hovedsageligt på vores egne ladepladser
            i Østerbro. Vores logistik er optimeret så svendene kører mindst muligt mellem opgaver,
            og vi planlægger aldrig en udrykning på tværs af byen, hvis en kollega allerede er i
            nabokvarteret. Det sparer både kunden tid og os CO2.
          </p>
          <p>
            Alt materiel sorteres og afleveres på godkendte modtageanlæg, kobber, kabler,
            lysstofrør, batterier og elektronik. Vi køber materialer i bulk for at reducere
            emballage, og vi bruger kun anerkendte producenter med dokumenteret levetid og
            reservedele, så installationen kan repareres frem for udskiftes.
          </p>
          <h2>Vores rådgivning</h2>
          <p>
            Den største klimaeffekt vi har, er gennem vores kunders installationer. Hver gang vi
            anbefaler en varmepumpe i stedet for et nyt oliefyr, en ladeboks i stedet for en
            forlængerledning, et solcelleanlæg i stedet for endnu et år med købsstrøm, sparer vi
            CO2 i et omfang vores egen drift aldrig kan matche. Derfor er energioptimering,
            varmepumper og grøn energi kerneydelser hos os, ikke tilvalg.
          </p>
          <p>
            Vi presser aldrig en grøn løsning ned over en kunde der ikke har brug for den. Men vi
            taler altid om totalomkostningen, anskaffelse plus drift over 10-15 år, og det
            betyder næsten altid, at den grønne løsning er billigere på den lange bane.
          </p>
        </>
      }
      bullets={[
        "Elbil-flåde på alle vores servicebiler",
        "Optimerede ruter for færre kilometer og mindre brændstof",
        "Sortering og certificeret genbrug af alt elskrot",
        "Materialer vælges efter levetid og reparérbarhed",
        "Vi anbefaler altid den mest energieffektive løsning",
        "CO2-beregning på større projekter",
      ]}
      features={[
        { title: "Vores drift", body: "Elbiler, ruteoptimering, affaldssortering og bulk-indkøb, vi minimerer vores eget aftryk." },
        { title: "Vores råd", body: "Vi anbefaler altid den løsning der har den bedste totaløkonomi inkl. drift og CO2, ikke den billigste i indkøb." },
        { title: "Vores løsninger", body: "Varmepumper, ladestandere, solceller og energioptimering er kerneydelser, vi tror på det vi sælger." },
      ]}
      faq={[
        { q: "Hvorfor er det vigtigt?", a: "Bygninger står for ca. 40% af Danmarks energiforbrug. Der ligger et enormt potentiale i at gøre eksisterende boliger mere effektive, og elektrikeren har en nøglerolle i den omstilling." },
        { q: "Får jeg dokumentation?", a: "Ved større projekter laver vi beregninger på CO2-besparelse og energi-effektivitet, som kan bruges til Bygningspuljen, energi­mærkning og din egen rapportering." },
        { q: "Hvad med affald?", a: "Vi sorterer alt elskrot og afleverer på godkendte modtageanlæg. Kobber og kabler genbruges, batterier og lysstofrør håndteres efter miljøkrav." },
        { q: "Er jeres elbiler nok?", a: "Nej, det er bare ét element. Den største effekt er gennem rådgivningen, men det er stadig vores ansvar at gå forrest i egen drift." },
      ]}
      related={[
        { to: "/varmepumper", title: "Varmepumper", body: "Den største enkelt-besparelse for de fleste danske villaer." },
        { to: "/groen-energi", title: "Grøn energi", body: "Solceller, batteri og smart styring, produktion og lagring i ét." },
        { to: "/energioptimering", title: "Energioptimering", body: "Find de største besparelser før du bygger nyt på." },
      ]}
    />
  ),
});
